interface SocialLinks {
  instagram: string;
  tiktok: string;
  facebook: string;
  picapic: string; 
}

export const socialLinks: SocialLinks = {
  instagram: process.env.REACT_APP_INSTAGRAM_URL || "https://www.instagram.com/3picapic?igsh=MXNkM25mcTJsZnRzcw%3D%3D&utm_source=qr",
  tiktok: process.env.REACT_APP_TIKTOK_URL || "https://www.tiktok.com/@picapic_officiel?_r=1&_t=ZN-95V7RwNDGBa",
  facebook: process.env.REACT_APP_FACEBOOK_URL || "https://facebook.com/picapic",
  picapic: process.env.REACT_APP_PICAPIC_URL || "https://wa.me/message/QZDSP5PP4RYIA1"
};

export const socialIcons = {
  instagram: (color: string = "currentColor", size: number = 20) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0z"/>
      <circle cx="18.406" cy="5.594" r="1.44"/>
    </svg>
  ),
  tiktok: (color: string = "currentColor", size: number = 20) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z"/>
    </svg>
  ),
  facebook: (color: string = "currentColor", size: number = 20) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.8c4.56-.93 8-4.96 8-9.8z"/>
    </svg>
  )
};

export const getSocialIcon = (
  platform: keyof typeof socialIcons, 
  color?: string, 
  size?: number
) => {
  return socialIcons[platform](color, size);
};